// import * as firebase from 'firebase/app';
import firebase from 'firebase/compat/app'; //v9
// import 'firebase/auth';
import 'firebase/compat/auth'; //v9
import 'firebase/compat/firestore'; //v9
import 'firebase/compat/storage'
// import 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCpCgpDI4Vg5Cp4z9RQ1WpH8KNIvu3k3hs",
  authDomain: "svelte-moodboard.firebaseapp.com",
  projectId: "svelte-moodboard",
  storageBucket: "svelte-moodboard.appspot.com",
  messagingSenderId: "4278717371",
  appId: "1:4278717371:web:5ebc78024611d64457929e",
  measurementId: "G-ZNGMX1JT18"
};

export const fb = firebase.initializeApp(firebaseConfig);

export const storage = firebase.storage();

export const auth = firebase.auth();
export const googleProvider = new firebase.auth.GoogleAuthProvider();

export const db = firebase.firestore();